
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/smart-chains/setup/interacting-with-smart-chains",
      function () {
        return require("private-next-pages/en/docs/smart-chains/setup/interacting-with-smart-chains/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/smart-chains/setup/interacting-with-smart-chains"])
      });
    }
  